import { ErrorBoundary } from 'react-error-boundary';
import { RouterProvider } from 'react-router';
import { CookiesProvider } from 'react-cookie';
import { GoogleOAuthProvider } from '@react-oauth/google';

import Error from '@components/error';
import { ReduxProvider } from '@redux/provider';
import ThemeProvider from '@providers/ThemeProvider';

import { router } from './navigation';

const COOKIE_MAX_AGE = 365 * 24 * 60 * 60;
const COOKIE_OPTIONS = {
  path: '/',
  maxAge: COOKIE_MAX_AGE,
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict' as const,
};

const App = () => {
  return (
    <ErrorBoundary FallbackComponent={Error}>
      <GoogleOAuthProvider
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}
      >
        <CookiesProvider defaultSetOptions={COOKIE_OPTIONS}>
          <ThemeProvider>
            <ReduxProvider>
              <RouterProvider router={router} />
            </ReduxProvider>
          </ThemeProvider>
        </CookiesProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
};

export default App;
